import { createFileRoute, redirect } from '@tanstack/react-router'

/** Tax rates moved into the settings hub (pages/settings.md §6.1): old links land there. */
export const Route = createFileRoute('/_app/tax-rates')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/tax-rates', replace: true })
  },
})
